import * as lib from '~/dependencies';
import { paddings, fonts, colors, margins } from '~/layout';

export const Container = lib.styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: ${paddings.alternative}px;

  .title {
    font-size: ${fonts.button}px;
    color: ${colors.black};
    margin-bottom: ${margins.inputBottom}px;
  }

  .reportInfo {
    height: 94px;
    border: 1px solid ${colors.lightGray06};
    border-radius: 10px;
    outline: none;
    padding: 10px;
  }

  .actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    flex: 1;
    margin-top: 20px;
    max-height: 35px;
  }
`;

export const ButtonCancel = lib.styled.button`
  outline: none;
  border: 0;
  box-shadow: none;
  background-color: transparent;
  color: ${colors.black};
  font-size: ${fonts.default}px;
  cursor: pointer;
  display: ${props => (props.hide ? 'none' : 'block')}
`;

export const BtnSubmit = lib.styled.button`
  display: flex;
  width: 112px;
  height: 30px;
  background: linear-gradient(50.28deg, #67C2E4 2.79%, #0C4BBC 73.37%);
  border-radius: 30px;
  outline: none;
  border: 0!important;
  font-weight: bold;
  font-size: ${fonts.btnSubmitLoginSize}px;
  text-align: center;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  cursor: pointer;

  .loading {
    color: ${colors.white};
    width: 15px!important;
    height: 15px!important;
  }

  span {
    opacity: ${props => (props.disabled ? 0.7 : 1)}
    color: ${colors.white};
    text-align: center;
    align-items: center;
    justify-content: center;
    font-size: ${fonts.btnSubmitLoginSize}px;
  }
`;
